import { makeMultiCurrencyFetchKey } from './cacheKeys';
import { fetchPortalCurrencies } from './multiCurrency';
import { wrapPromise } from 'persist-promise/wrapPromise';
export const multiCurrencyPersistedPromise = wrapPromise({
  namespace: 'FDSR',
  entityName: 'multiCurrency',
  deepFreeze: true,
  toCacheKey: makeMultiCurrencyFetchKey,
  fetch: fetchPortalCurrencies
});